import request from '@/router/axios'

export function fetchPostList (query) {
    return request({
      url: '/post/admin/posts/page',
      method: 'get',
      params: query
    })
}

export function getPostTotal () {
  return request({
    url: '/post/admin/posts/total',
    method: 'get',
  })
}

export function getPost (id) {
    return request({
      url: '/post/admin/posts/' + id,
      method: 'get'
    })
}

export function updatePostBanStatus (obj) {
    return request({
      url: '/post/admin/posts/banStatus',
      method: 'put',
      data: obj
    })
}

export function updatePostCommentStatus (obj) {
  return request({
    url: '/post/admin/posts/commentStatus',
    method: 'put',
    data: obj
  })
}

export function fetchPostCommentList (query) {
    return request({
      url: '/post/admin/comments/page',
      method: 'get',
      params: query
    })
}

export function fetchPostVoteList (query) {
  return request({
    url: '/post/admin/vote/result/page',
    method: 'get',
    params: query
  })
}

export function fetchPostLikeList(query) {
  return request({
    url: '/post/admin/like/post/page',
    method: 'get',
    params: query
  });
}

export function fetchPostTipList(query) {
  return request({
    url: '/admin/admin/tip-record/post/page',
    method: 'get',
    params: query
  });
}

export function fetchPostFavoriteList(query) {
  return request({
    url: '/admin/member-favorite/post/page',
    method: 'get',
    params: query
  });
}

export function fetchPostComplaintList(query) {
  return request({
    url: '/post/admin/complaint/page',
    method: 'get',
    params: query
  });
}

export function createPost(params) {
  return request({
    url: `/post/admin/posts/post`,
    method: 'POST',
    data: params
  })
}

export function updatePost(params) {
  return request({
    url: `/post/admin/posts/post`,
    method: 'PUT',
    data: params
  })
}

export function updatePostTopStatus(params) {
  return request({
    url: '/post/admin/posts/top',
    method: 'PUT',
    data: params
  });
}

export function getYesterdayStatistics() {
  return request({
    url: '/post/admin/posts/yesterday/statistics',
    method: 'GET',
  });
}

export function updateManualHeatValue(params) {
  return request({
    url: '/post/admin/posts/manual',
    method: 'put',
    params: params,
  });
}

export function removePost(id) {
  return request({
    url: '/post/admin/posts/' + id,
    method: 'delete'
  });
}

export function removeSelfPost(id) {
  return request({
    url: '/post/admin/posts/self/' + id,
    method: 'delete'
  });
}

export function exportPost(obj) {
  return request({
    url: '/post/admin/posts/export',
    method: 'post',
    data: obj,
  })
}

export function exportCirclePost(obj) {
  return request({
    url: '/post/admin/posts/export/circle',
    method: 'post',
    data: obj,
  })
}